import Header from "../Component/UserEnd/Header";
import LegacyTitle from "../Component/UserEnd/LegacyTitle";
import LegacyContent from "../Component/UserEnd/LegacyContent";
import Footer from "../Component/UserEnd/Footer";

function LegacyPage() {
    return (
        <>
            <Header />
            <LegacyTitle/>
            <LegacyContent/>
            <Footer />
        </>
    );
}

export default LegacyPage;
